import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-guide",
  "use": "icon-guide-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-guide\">\r\n<path id=\"icon-guide_路径_1863\" d=\"M19.5,0.5L7.6,13.6l-7.2-2.4L19.5,0.5z M19.5,0.5v16.7l-10.1-3L19.5,0.5z M7.6,14.3l-0.4-0.1l2.7,5.4\r\n\tl1.8-4.1l-2.4-0.7l0.4,3.6L7.6,14.3z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol